import { gql } from 'graphql-request'

export const cartGraphQLQuery = gql`
  query cartLineItems($ids: [ID!]!, $namespace: String!) {
    nodes(ids: $ids) {
      ... on Product {
        id
        title
        handle
        tags
        onlineStoreUrl
        weeklyrental: metafield(namespace:$namespace, key: "weeklyrental") {
          value
        }
        rentalprice: metafield(namespace:$namespace, key: "rentalprice") {
          value
        }
        variants(first: 1) {
          edges {
            node {
              sku
            }
          }
        }
        price: priceRange {
          maxVariantPrice {
            amount
          }
        }
      }
    }
  }
`
